import React from "react"
import * as styles from './feature-box.module.css'

export default function FeatureBox({children}) {
    return (
        <div className={styles.featureBox}>
            <div className={styles.featureBox_inner}>
                {children}
            </div>
        </div>
    )
}